<template>
  <div class="navbar">
    <hamburger
      id="hamburger-container"
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />

    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" v-if="!topNav" />
    <top-nav id="topmenu-container" class="topmenu-container" v-if="topNav" />

    <div class="right-menu">
      <template v-if="device !== 'mobile'">
        <a
          :href="
            'https://safe.ezbeidou.com/admin.php/ajax/xrlogin?username=' +
            username +
            '&time=' +
            time +
            '&hmac=' +
            hmac
          "
          target="_blank"
        >
          <el-tag class="label">安全培训</el-tag>
        </a>
        <a href="http://58.58.90.178:8833" target="_blank">
          <el-tag class="label">旧平台入口</el-tag>
        </a>
<!--        <a href="https://car.visfx.cn/yonghuzhongxin.html" target="_blank">-->
<!--          <el-tag class="label">用户手册</el-tag>-->
<!--        </a>-->
        <a href="http://www.ezbeidou.com/home" target="_blank">
          <el-tag class="label">大屏轮播</el-tag>
        </a>
        <!-- <router-link to="/monitor/online"><el-tag  class="label">大屏轮播</el-tag> </router-link> -->
        <el-switch
          v-model="$store.state.user.gqnote"
          @change="noticeChange"
          style="margin-top: 15px"
          class="label"
          active-text="过期提醒"
          inactive-text=""
        >
        </el-switch>
        <router-link :to="{ path: '/warning/systems' }">
          <span class="label" style="font-size: 14px">
            <i
              class="el-icon-message-solid label"
              style="color: #f56c6c; font-size: 26px; margin-right: 0"
            ></i>
            报警管理
          </span>
        </router-link>
        <!--        <el-tag  class="label">大屏轮播</el-tag>-->
        <!--        <search id="header-search" class="right-menu-item" />-->
        <!--        -->
        <!--        <el-tooltip content="源码地址" effect="dark" placement="bottom">-->
        <!--          <ruo-yi-git id="ruoyi-git" class="right-menu-item hover-effect" />-->
        <!--        </el-tooltip>-->

        <!--        <el-tooltip content="文档地址" effect="dark" placement="bottom">-->
        <!--          <ruo-yi-doc id="ruoyi-doc" class="right-menu-item hover-effect" />-->
        <!--        </el-tooltip>-->

        <!--        <screenfull id="screenfull" class="right-menu-item hover-effect" />-->

        <!--        <el-tooltip content="布局大小" effect="dark" placement="bottom">-->
        <!--          <size-select id="size-select" class="right-menu-item hover-effect" />-->
        <!--        </el-tooltip>-->
      </template>
      <span class="label" style="font-size: 14px">{{
        $store.state.user.deptName ? $store.state.user.deptName : ""
      }}</span>
      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
        <div class="avatar-wrapper">
          <img :src="avatar" class="user-avatar" />
          <span style="display: inline-block; vertical-align: middle; font-size: 14px">{{
            name
          }}</span>
          <i class="el-icon-caret-bottom" />
        </div>

        <el-dropdown-menu slot="dropdown">
          <router-link to="/user/profile">
            <el-dropdown-item>个人中心</el-dropdown-item>
          </router-link>
          <el-dropdown-item @click.native="setting = true">
            <span>布局设置</span>
          </el-dropdown-item>
          <el-dropdown-item divided @click.native="logout">
            <span>退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { authSafe, editExpired } from "@/api/system/user";
import Breadcrumb from "@/components/Breadcrumb";
import TopNav from "@/components/TopNav";
import Hamburger from "@/components/Hamburger";
import Screenfull from "@/components/Screenfull";
import SizeSelect from "@/components/SizeSelect";
import Search from "@/components/HeaderSearch";
import RuoYiGit from "@/components/RuoYi/Git";
import RuoYiDoc from "@/components/RuoYi/Doc";

export default {
  data() {
    return {
      username: "",
      time: "",
      hmac: "",
    };
  },
  components: {
    Breadcrumb,
    TopNav,
    Hamburger,
    Screenfull,
    SizeSelect,
    Search,
    RuoYiGit,
    RuoYiDoc,
  },
  computed: {
    ...mapGetters(["sidebar", "avatar", "device", "name"]),
    setting: {
      get() {
        return this.$store.state.settings.showSettings;
      },
      set(val) {
        this.$store.dispatch("settings/changeSetting", {
          key: "showSettings",
          value: val,
        });
      },
    },
    topNav: {
      get() {
        return this.$store.state.settings.topNav;
      },
    },
  },

  mounted() {
    this.getUserSafe();
  },
  methods: {
    noticeChange(e) {
      let n;
      if (e) {
        n = "0";
      } else {
        n = "1";
      }
      editExpired(n).then((res) => {});
    },
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    async logout() {
      this.$confirm("确定注销并退出系统吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$store.dispatch("LogOut").then(() => {
            location.href = "/index";
          });
        })
        .catch(() => {});
    },
    getUserSafe() {
      authSafe().then((res) => {
        if (res.code === 200) {
          this.username = res.data.username;
          this.time = res.data.time;
          this.hmac = res.data.hmac;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .topmenu-container {
    position: absolute;
    left: 50px;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    .label {
      vertical-align: top;
      margin-top: 10px;
      margin-right: 10px;
    }

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        position: relative;
        display: flex;
        align-items: center;

        .user-avatar {
          cursor: pointer;
          width: 30px;
          height: 30px;
          border-radius: 10px;
          margin-right: 3px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
